import { Theme } from '@material-ui/core';

export const MuiSkeleton = (theme: Theme): Record<string, unknown> => ({
  root: {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
});
